/**
 * Endpoints del backend de Zurich para los siniestros de un item (relativos a `${VUE_APP_BACKEND}/web/api/`).
 * Copiados de `ItemWithSinistersUrls` (repo de Zurich, `features/core/api/item-with-sinisters.ts`).
 * Los endpoints del item (`/ranch/`, `/ranch/list/`, ...) están en `tenants/shared/api/ranch-item-urls.ts`.
 */
export enum ItemClaimsUrls {
   DETAIL_INFO = '/ranch/claims/',
   SINISTER_NOTES = '/ranch/notes/',
   SATELLITAL_IMAGES = '/ranch/satellital/images/',
   SATELLITAL_VALUES = '/ranch/satellital/values/',
   STATS_SATELLITAL_VALUES = '/ranch/satellital/values/stats/',
   MAP_LAYERS = '/ranch/satellital/map_layers/',

   ZONIFICATION = '/ranch/satellital/ndvi_zonify/',
   NDVI_DIFF = '/ranch/satellital/ndvi_diff/',
   SAMPLING_CLASSIFICATION = '/ranch/sampling/classification/'
}
